<template>
	<PageIntroduction />
	<div class="page-shop u-s-p-t-80">
		<div class="container products_by_category">
			<!-- Shop-Intro -->
			<ShopIntro />
			<!-- Shop-Intro /- -->
			<div class="row">
				<!-- Shop-Left-Side-Bar-Wrapper -->
				<Sidebar @filterParams="filterProductsType" />
				<!-- Shop-Left-Side-Bar-Wrapper /- -->
				<!-- Shop-Right-Wrapper -->
				<div class="col-lg-9 col-md-9 col-sm-12">
					<!-- Page-Bar -->
					<SortBar @sortBy="SortProducts" />
					<!-- {{getStatus}} -->
					<!-- Page-Bar /- -->
					<!-- Row-of-Product-Container -->
					<div class="row product-container grid-style">
						<div style="width: 100%">
							<Spinner v-if="getStatus.products.loading" />
						</div>
						<!-- Product Not Found -->
						<div
							class="product-not-found"
							v-if="getProducts.length == 0 && !getStatus.products.loading"
							style="width: 100%"
						>
							<div class="not-found">
								<h2>SORRY!</h2>
								<!-- 28.9844646 -->
								<h6>There is not any products in this category.</h6>
							</div>
						</div>
						<!-- Product Not Found /- -->
						<div
							v-if="!getStatus.products.loading"
							class="products_div row"
							ref="product_div"
							id="product_div"
						>
							<Product
								:product="product"
								v-for="product in getProducts.products.data"
								:key="product.id"
								:sortBy="sortBy"
							/>
							<Spinner
								style="width: 100%; height: 200px"
								v-if="getStatus.updateProducts.loading"
							/>
							<div
								class="redirect-link-wrapper text-center u-s-p-t-25 u-s-p-b-80"
								style="width: 100%"
								v-if="
									!getStatus.updateProducts.loading &&
									getLastPage != pageNo &&
									getProducts.length != 0
								"
							>
								<a class="redirect-link" href="#" @click.prevent="viewMore"
									>View more on this category</a
								>
							</div>

							<div
								class="redirect-link-wrapper text-center u-s-p-t-25 u-s-p-b-80"
								style="width: 100%"
								v-if="
									!getStatus.updateProducts.loading &&
									getLastPage == pageNo &&
									getProducts.length != 0
								"
							>
								<a class="redirect-link">No More Products..</a>
							</div>
						</div>
					</div>
					<!-- Row-of-Product-Container /- -->
				</div>
				<!-- Shop-Right-Wrapper /- -->
			</div>
		</div>
	</div>
	<Footer />
</template>

<script>
	import PageIntroduction from "../components/Shop/PageIntroduction.vue";
	import Footer from "../components/Bottom/Footer.vue";
	import ShopIntro from "../components/Shop/ShopIntro.vue";
	import {publicPath} from "../../vue.config";
	import Spinner from "../components/Loaders/Spinner.vue";
	import Sidebar from "../components/Sections/Products/Sidebar/Sidebar.vue";
	import {mapActions, mapGetters} from "vuex";
	import StarRating from "vue-star-rating";
	import SortBar from "../components/Sections/Products/SortBar/SortBart.vue";
	import {useToast} from "vue-toastification";
	import {ContentLoader} from "vue-content-loader";
	import {formatCurrency} from "../utils/common_functions";
	import Product from "../components/Sections/Product.vue";
	export default {
		components: {
			PageIntroduction,
			Footer,
			ShopIntro,
			Spinner,
			Sidebar,
			StarRating,
			SortBar,
			ContentLoader,
			Product,
		},
		data() {
			return {
				API_URL: process.env.VUE_APP_API_URL,
				publicPath: publicPath,
				startY: 0,
				loading: false,
				pageNo: 1,
				params: null,
				sortBy: "featured",
			};
		},
		computed: {
			...mapGetters("products", [
				"getProducts",
				"getStatus",
				"getBrands",
				"getLastPage",
			]),
			...mapGetters("cat", ["getCategories"]),
		},
		methods: {
			...mapActions("products", [
				"getBestSellerProducts",
				"getNewArrivals",
				"fetchProducts",
				"getFeaturedProducts",
				"getTopLiked",
				"fetchBrands",
				"getProductByType",
			]),
			...mapActions("cart", ["addToCart"]),
			...mapActions("wishlist", ["addProductToWislist"]),
			formatCurrency,
			scroll() {
				const el = document.getElementsByClassName("page-shop")[0];
				this.$smoothScroll({
					scrollTo: el, // scrollTo is also allowed to be number
				});
			},
			//filter Products By Price.
			filterProductsType(params) {
				this.pageNo = 1;
				this.params = params;
				this.getProductByType({...params, sortBy: this.sortBy});
				this.scroll();
			},
			//Sorting Products
			SortProducts(type) {
				this.pageNo = 1; //resetting Pagination.
				this.sortBy = type;
				this.getProductByType({
					id: this.$route.params.id,
					...this.params,
					sortBy: this.sortBy,
				});
			},

			_addToCart(data) {
				this.addToCart(data);
			},
			addToWishlist(data) {
				this.addProductToWislist(data);
			},
			//View More Handler (For Lazy Loading)
			viewMore() {
				this.pageNo = this.pageNo + 1;
				this.getProductByType({
					id: this.$route.params.id,
					...this.params,
					pageNo: this.pageNo,
					sortBy: this.sortBy,
				});
			},

			filterProducts(type) {
				if (type == "best-seller") {
					this.getBestSellerProducts();
				} else if (type == "new-arrivals") {
					this.getNewArrivals();
				} else if (type == "top-liked") {
					this.getTopLiked();
				} else if (type == "featured") {
					this.getProductByType({
						...this.params,
						pageNo: this.pageNo,
						sortBy: this.sortBy,
					});
				} else {
					this.$router.push({name: "Home"});
					useToast().error("No Products In this type.", {timeout: 3000});
				}
			},
		},
		mounted() {
			// this.getProductByType(this.$route.params.type);
			this.filterProducts(this.$route.params.type);
			this.fetchBrands();
			this.scroll();
		},
		watch: {
			$route(to, from) {
				if (to.params.type) {
					this.filterProducts(this.$route.params.type);
					this.scroll();
				}
			},
		},
	};
</script>

<style>
	.active {
		font-weight: bold;
	}
	.products_div {
		width: 100%;
	}
</style>
